"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_result_1 = require("./validation-result");
const dig_1 = require("../objects/dig");
const wrap_1 = require("../arrays/wrap");
/**
 * Run the given validators to determine if the subject is valid.
 *
 * @Param {any} subject       - The subject to run validation on.
 * @Param {Object} validators - The validators to run. Defined in an object
 *                              where the keys are the properties to validate
 *                              and the value the validator to run.
 *
 * @Example
 *
 *   validate({ name: "Bob" }, { name: isMinLength(3) })
 *   //=> { isSuccessful: true, errors: [] }
 *
 *   validate({ name: "Bob" }, { name: isMinLength(5) })
 *   //=> {
 *     isSuccessful: false,
 *     errors: [{ message: 'name must be longer than 5' }]
 *   }
 */
function validate(subject, validators) {
    return Object.entries(validators).reduce((result, [property, propertyValidators]) => {
        const value = dig_1.dig(subject, property);
        const errors = [
            ...result.errors,
            ...wrap_1.wrap(propertyValidators).reduce((acc, validator) => [...acc, ...validator(property, value).errors], []),
        ];
        return new validation_result_1.ValidationResult(errors);
    }, new validation_result_1.ValidationResult([]));
}
exports.validate = validate;
//# sourceMappingURL=validate.js.map